// extracted by mini-css-extract-plugin
export default {"globalStyle":"global_globalStyle__kwmpP","mainApp":"global_mainApp__dfWix"};